import { render } from "./VInputNumber.vue?vue&type=template&id=4b943337&scoped=true"
import script from "./VInputNumber.vue?vue&type=script&lang=js"
export * from "./VInputNumber.vue?vue&type=script&lang=js"

import "./VInputNumber.vue?vue&type=style&index=0&id=4b943337&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b943337"]])

export default __exports__